export interface MarketPaymentKey {
  key: string;
  key_encrypted?: boolean;
}

export const MARKET_KEY_UNAVAILABLE_MESSAGE =
  '결제 정보를 불러오지 못했어요. 잠시 후 다시 시도해주세요.';

/**
 * payment-info 응답에서 마켓 토스 클라이언트 키를 꺼낸다.
 * 서버가 평문 키(key_encrypted === false)를 보낸 경우에만 쓴다.
 * 암호화된 키(key_encrypted가 true이거나 없음)는 더 풀 수 없으므로 결제를 멈추도록 안내 문구를 던진다.
 * 결제 화면은 String(error)로 토스트를 띄우므로 Error가 아닌 문자열을 던진다(payment.ts와 같은 방식).
 * key가 비어 있으면(정보 조회 실패) 종전처럼 undefined를 돌려준다.
 */
export const resolveMarketClientKey = ({ key, key_encrypted }: MarketPaymentKey) => {
  if (!key) return undefined;
  if (key_encrypted !== false) {
    console.error('market payment key is encrypted; expected a plaintext key', { key_encrypted });
    throw MARKET_KEY_UNAVAILABLE_MESSAGE;
  }
  return key;
};
